import { approvalRequestCreatedV1, approvalRequestDecidedV1, approvalRequestEscalatedV1, } from "./approvals.v1.js";
import { fiscalPeriodStatusChangedV1, journalEntryPostedV1, journalEntryReversedV1, postingExceptionRaisedV1, } from "./accounting.v1.js";
import { counterpartyAllocationChangedV1, counterpartyChangedV1, counterpartyLedgerMismatchV1, counterpartyTransactionCancelledV1, counterpartyTransactionPostedV1, } from "./counterparties.v1.js";
import { demoNoteCreatedV1, demoNoteStatusChangedV1 } from "./demo-notes.v1.js";
import { fuelCostRecalculatedV1, fuelReconciliationApprovedV1, fuelReconciliationClassifiedV1, fuelTotalizerAnomalyDetectedV1, fuelDeliveryConfirmedV1, fuelDeliveryVarianceExceededV1, fuelIngestBatchReceivedV1, fuelPriceStaleSaleDetectedV1, } from "./fuel.v1.js";
import { expenseApprovedV1, expenseCancelledV1, expenseSubmittedV1, recurringExpenseGeneratedV1, } from "./expenses.v1.js";
import { paymentBatchApprovedV1, paymentBatchExecutedV1, paymentBatchSubmittedV1 } from "./payments.v1.js";
import { taxObligationDueV1 } from "./tax-calendar.v1.js";
import { cashflowShortfallProjectedV1 } from "./cashflow.v1.js";
import { budgetVarianceExceededV1 } from "./budget.v1.js";
import { complianceDocumentChangedV1, maintenanceWorkOrderCreatedV1, maintenanceWorkOrderStatusChangedV1, } from "./maintenance.v1.js";
import { platformAnnouncementPublishedV1, platformDataExportRequestedV1, platformInvoiceIssuedV1, platformSubscriptionChangedV1, platformSupportAccessChangedV1, platformTenantStatusChangedV1, } from "./platform.v1.js";
import { priceChangeCancelledV1, priceChangedV1, priceChangeScheduledV1 } from "./pricing.v1.js";
import { instrumentBatchCancelledV1, instrumentBatchPostedV1, instrumentBouncedV1, instrumentReminderDueV1, } from "./instruments.v1.js";
import { earchiveRequestedV1, edocumentFailedV1, edocumentStatusChangedV1, incomingInvoiceReceivedV1, incomingResponseDueV1, invoiceCancelledV1, invoiceIssuedV1, } from "./invoicing.v1.js";
import { agentClockSkewDetectedV1, agentCommandCreatedV1, agentCommandFinishedV1, agentCommandPriceUpdateFailedV1, agentDeviceAlarmRaisedV1, agentEnrolledV1, agentOfflineV1, agentOnlineV1, agentRevokedV1, agentSyncBatchReceivedV1, agentSyncGapSkippedV1, } from "./agents.v1.js";
import { posCreditLimitExceededOfflineV1, posSaleAfterDayLockV1, posSaleFiscalSkippedV1, posSaleRecordedV1, posSaleRetenderedV1, posSaleVoidedV1, } from "./pos.v1.js";
import { marketCountApprovedV1, marketCountSubmittedV1, marketDailyClosingClosedV1, marketGoodsReceiptCancelledV1, marketGoodsReceiptPostedV1, marketInvoiceMatchCostFinalizedV1, marketInvoiceMatchCreatedV1, marketInvoiceMatchUnmatchedV1, marketLicenseExpiredV1, marketLicenseExpiringV1, marketLotExpiredV1, marketLotExpiringV1, marketOpeningStockRecordedV1, marketPurchaseOrderStatusChangedV1, marketStockNegativeV1, marketTransferCancelledV1, marketTransferReceivedV1, marketTransferSentV1, marketWriteOffPostedV1, marketWriteOffRejectedV1, } from "./market.v1.js";
import { customerDriverLinkedV1, customerDriverUnlinkedV1, customerProfileAnonymizedV1, customerProfileCreatedV1, } from "./customers.v1.js";
import { marketingBatchSentV1, privacyConsentRecordedV1, privacyMessagePermissionChangedV1, privacyRequestCompletedV1, privacyRequestDueSoonV1, privacyRequestOverdueV1, privacyRequestReceivedV1, } from "./privacy.v1.js";
import { fleetBillingCancelledV1, fleetBillingIssuedV1, fleetRuleViolatedV1, fleetVehicleRequestCreatedV1, fleetVehicleRequestDecidedV1, } from "./fleet.v1.js";
import { loyaltyAbuseSuspectedV1, loyaltyCouponDoubleRedemptionV1, loyaltyCouponRedeemedV1, loyaltyPointsEarnedV1, loyaltyPointsExpiredV1, loyaltyPointsExpiringV1, loyaltyPointsOverdrawnV1, loyaltyPointsRedeemedV1, loyaltySubscriptionActivatedV1, loyaltySubscriptionOverusedV1, loyaltyTierChangedV1, } from "./loyalty.v1.js";
import { washActivationChangedV1, washAppointmentChangedV1, washCreditNegativeBalanceV1, washCycleRecordedV1, washUnitFaultClearedV1, washUnitFaultStartedV1, washUnitStatusChangedV1, washWorkOrderReadyNotifiedV1, washWorkOrderStatusChangedV1, } from "./wash.v1.js";
import { evChargerBootedV1, evChargerConnectedV1, evChargerDisconnectedV1, evChargerFaultClearedV1, evChargerFaultStartedV1, evCommandFinishedV1, evConnectorStatusChangedV1, evLoadRebalancedV1, evPartnerImportCompletedV1, evSessionCompletedV1, evSessionDoublePaymentV1, evSessionPaidV1, evSessionPaymentRevertedV1, evSessionStartedV1, evSessionUpdatedV1, } from "./ev.v1.js";
import { alarmEscalatedV1, alarmRaisedV1, alarmResolvedV1, alarmUpdatedV1, notificationCreatedV1, } from "./alarms.v1.js";
import { shiftApprovedV1, shiftAssignmentHandedOverV1, shiftCancelledV1, shiftCashDropRecordedV1, shiftClosedV1, shiftClosingAcceptedV1, shiftClosingDifferenceExceededV1, shiftCreditSaleRecordedV1, shiftDayClosedV1, shiftDayUnclosedV1, shiftOpenedV1, shiftOpenTooLongV1, shiftZReportMismatchV1, } from "./shifts.v1.js";
import { bankStatementImportedV1, cashCountDecidedV1, cashCountDifferenceV1, dbsLimitChangedV1, posSettlementMismatchV1, treasuryReminderDueV1, treasuryTransactionCancelledV1, treasuryTransactionPostedV1, } from "./treasury.v1.js";
export * from "./registry.js";
export * from "./maintenance.v1.js";
export * from "./platform.v1.js";
export * from "./demo-notes.v1.js";
export * from "./pricing.v1.js";
export * from "./accounting.v1.js";
export * from "./counterparties.v1.js";
export * from "./treasury.v1.js";
export * from "./instruments.v1.js";
export * from "./invoicing.v1.js";
export * from "./approvals.v1.js";
export * from "./expenses.v1.js";
export * from "./tax-calendar.v1.js";
export * from "./payments.v1.js";
export * from "./cashflow.v1.js";
export * from "./budget.v1.js";
export * from "./fuel.v1.js";
export * from "./shifts.v1.js";
export * from "./agents.v1.js";
export * from "./pos.v1.js";
export * from "./market.v1.js";
export * from "./fleet.v1.js";
export * from "./customers.v1.js";
export * from "./privacy.v1.js";
export * from "./loyalty.v1.js";
export * from "./wash.v1.js";
export * from "./ev.v1.js";
export * from "./alarms.v1.js";
/** Tüm olay tanımları. Yeni olay eklendiğinde buraya da kaydedilir. */
export const EVENT_DEFINITIONS = [
    demoNoteCreatedV1,
    demoNoteStatusChangedV1,
    priceChangedV1,
    priceChangeScheduledV1,
    priceChangeCancelledV1,
    journalEntryPostedV1,
    journalEntryReversedV1,
    postingExceptionRaisedV1,
    fiscalPeriodStatusChangedV1,
    counterpartyChangedV1,
    counterpartyTransactionPostedV1,
    counterpartyTransactionCancelledV1,
    counterpartyAllocationChangedV1,
    counterpartyLedgerMismatchV1,
    bankStatementImportedV1,
    cashCountDecidedV1,
    cashCountDifferenceV1,
    dbsLimitChangedV1,
    posSettlementMismatchV1,
    treasuryReminderDueV1,
    treasuryTransactionCancelledV1,
    treasuryTransactionPostedV1,
    instrumentBatchPostedV1,
    instrumentBatchCancelledV1,
    instrumentBouncedV1,
    instrumentReminderDueV1,
    invoiceIssuedV1,
    invoiceCancelledV1,
    edocumentStatusChangedV1,
    edocumentFailedV1,
    incomingInvoiceReceivedV1,
    incomingResponseDueV1,
    earchiveRequestedV1,
    approvalRequestCreatedV1,
    approvalRequestDecidedV1,
    approvalRequestEscalatedV1,
    expenseSubmittedV1,
    expenseApprovedV1,
    expenseCancelledV1,
    recurringExpenseGeneratedV1,
    taxObligationDueV1,
    paymentBatchSubmittedV1,
    paymentBatchApprovedV1,
    paymentBatchExecutedV1,
    cashflowShortfallProjectedV1,
    budgetVarianceExceededV1,
    fuelIngestBatchReceivedV1,
    fuelDeliveryConfirmedV1,
    fuelDeliveryVarianceExceededV1,
    fuelCostRecalculatedV1,
    fuelReconciliationClassifiedV1,
    fuelReconciliationApprovedV1,
    fuelTotalizerAnomalyDetectedV1,
    fuelPriceStaleSaleDetectedV1,
    shiftOpenedV1,
    shiftCancelledV1,
    shiftAssignmentHandedOverV1,
    shiftCashDropRecordedV1,
    shiftCreditSaleRecordedV1,
    shiftClosingDifferenceExceededV1,
    shiftClosingAcceptedV1,
    shiftClosedV1,
    shiftApprovedV1,
    shiftZReportMismatchV1,
    shiftDayClosedV1,
    shiftOpenTooLongV1,
    shiftDayUnclosedV1,
    agentEnrolledV1,
    agentRevokedV1,
    agentOnlineV1,
    agentOfflineV1,
    agentClockSkewDetectedV1,
    agentDeviceAlarmRaisedV1,
    agentCommandCreatedV1,
    agentCommandFinishedV1,
    agentCommandPriceUpdateFailedV1,
    agentSyncBatchReceivedV1,
    agentSyncGapSkippedV1,
    posSaleRecordedV1,
    posSaleVoidedV1,
    posSaleAfterDayLockV1,
    posCreditLimitExceededOfflineV1,
    posSaleFiscalSkippedV1,
    posSaleRetenderedV1,
    marketTransferSentV1,
    marketTransferReceivedV1,
    marketTransferCancelledV1,
    marketWriteOffPostedV1,
    marketWriteOffRejectedV1,
    marketCountSubmittedV1,
    marketCountApprovedV1,
    marketDailyClosingClosedV1,
    marketStockNegativeV1,
    marketOpeningStockRecordedV1,
    marketPurchaseOrderStatusChangedV1,
    marketGoodsReceiptPostedV1,
    marketGoodsReceiptCancelledV1,
    marketInvoiceMatchCreatedV1,
    marketInvoiceMatchCostFinalizedV1,
    marketInvoiceMatchUnmatchedV1,
    marketLicenseExpiringV1,
    marketLicenseExpiredV1,
    marketLotExpiringV1,
    marketLotExpiredV1,
    customerProfileCreatedV1,
    customerProfileAnonymizedV1,
    customerDriverLinkedV1,
    customerDriverUnlinkedV1,
    privacyConsentRecordedV1,
    privacyMessagePermissionChangedV1,
    privacyRequestReceivedV1,
    privacyRequestDueSoonV1,
    privacyRequestOverdueV1,
    privacyRequestCompletedV1,
    marketingBatchSentV1,
    fleetRuleViolatedV1,
    fleetBillingIssuedV1,
    fleetBillingCancelledV1,
    fleetVehicleRequestCreatedV1,
    fleetVehicleRequestDecidedV1,
    loyaltyPointsEarnedV1,
    loyaltyPointsRedeemedV1,
    loyaltyPointsOverdrawnV1,
    loyaltyPointsExpiringV1,
    loyaltyPointsExpiredV1,
    loyaltyAbuseSuspectedV1,
    loyaltyTierChangedV1,
    loyaltyCouponRedeemedV1,
    loyaltyCouponDoubleRedemptionV1,
    loyaltySubscriptionActivatedV1,
    loyaltySubscriptionOverusedV1,
    washCycleRecordedV1,
    washUnitFaultStartedV1,
    washUnitFaultClearedV1,
    washUnitStatusChangedV1,
    washActivationChangedV1,
    washCreditNegativeBalanceV1,
    washWorkOrderStatusChangedV1,
    washWorkOrderReadyNotifiedV1,
    washAppointmentChangedV1,
    evChargerConnectedV1,
    evChargerDisconnectedV1,
    evChargerBootedV1,
    evConnectorStatusChangedV1,
    evChargerFaultStartedV1,
    evChargerFaultClearedV1,
    evSessionStartedV1,
    evSessionUpdatedV1,
    evSessionCompletedV1,
    evSessionPaidV1,
    evSessionDoublePaymentV1,
    evSessionPaymentRevertedV1,
    evCommandFinishedV1,
    evLoadRebalancedV1,
    evPartnerImportCompletedV1,
    alarmRaisedV1,
    alarmUpdatedV1,
    alarmResolvedV1,
    alarmEscalatedV1,
    notificationCreatedV1,
    maintenanceWorkOrderCreatedV1,
    maintenanceWorkOrderStatusChangedV1,
    complianceDocumentChangedV1,
    platformTenantStatusChangedV1,
    platformSubscriptionChangedV1,
    platformInvoiceIssuedV1,
    platformSupportAccessChangedV1,
    platformDataExportRequestedV1,
    platformAnnouncementPublishedV1,
];
const byKey = new Map(EVENT_DEFINITIONS.map((definition) => [`${definition.type}@${definition.version}`, definition]));
export function findEventDefinition(type, version) {
    return byKey.get(`${type}@${version}`);
}
//# sourceMappingURL=index.js.map